module.exports = __webpack_public_path__ + "videos/webpush-safari-desktop.7184338.webm";